import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserSessionPatch = {
    path: "/user/session",
    method: ERouteHttpVerb.PATCH
};
export { routeLocationUserSessionPatch };
